import firebase from "../../firebase"
import { TypeArray, FirestoreTimestampType } from "../types"
import { reducerTypeGuard } from "../reducers/reducerGuards"
import { actionCreatorTypeGuard } from "../reducers/actionCreators"

export type ExerciseState = {
  completed: boolean
  completed_timestamp: FirestoreTimestampType | null
}

const reducerAction = {
  completed: actionCreatorTypeGuard<ExerciseState, boolean>(
    "completed",
    "ExerciseState"
  ),
  completed_timestamp: actionCreatorTypeGuard<
    ExerciseState,
    FirestoreTimestampType | null
  >("completed_timestamp", "ExerciseState"),
  __record: actionCreatorTypeGuard<TypeArray, ExerciseState>(
    "ExerciseState",
    "__record"
  ),
  __create: actionCreatorTypeGuard<TypeArray, null | Partial<ExerciseState>>(
    "create",
    "__create/ExerciseState"
  ),
  __null: actionCreatorTypeGuard<TypeArray, null>("null", "__record")
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in
    | keyof ExerciseState
    | "__record"
    | "__null"
    | "__create"]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const exerciseStateAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const exerciseStateReducer = reducerTypeGuard<ExerciseState>()
  .case(exerciseStateAction.completed, (state, completed) => ({
    ...state,
    completed: completed,
    completed_timestamp: firebase.firestore.Timestamp.now()
  }))
  .case(...reducerAction.completed_timestamp)
  .build()
